import React, { Fragment } from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle, CheckCircle2 } from 'lucide-react';
const pains = [{
  emoji: '😩',
  text: 'Me levanto cansada aunque dormí 8 horas'
}, {
  emoji: '🌪️',
  text: 'A la tarde ya no puedo más con nada'
}, {
  emoji: '😤',
  text: 'Estoy irritable sin razón y no entiendo por qué'
}];
const cycle = [{
  emoji: '😰',
  text: 'Estrés que no para',
  detail: 'tu mente no apaga nunca'
}, {
  emoji: '🔥',
  text: 'Cortisol por las nubes',
  detail: 'tu cuerpo entra en modo "peligro"'
}, {
  emoji: '🤯',
  text: 'Intestino inflamado + sistema nervioso',
  detail: 'en alerta MÁXIMA'
}, {
  emoji: '😵',
  text: 'Fatiga profunda, ansiedad,',
  detail: 'hinchazón que no cede'
}, {
  emoji: '🔄',
  text: 'Te dormís exhausta...',
  detail: 'y mañana empieza TODO de nuevo.'
}];
const negatives = [{
  title: 'Dormir más no te repara',
  detail: 'porque tu cortisol sigue alto a las 3am'
}, {
  title: 'Comer sano no alcanza',
  detail: 'si tu intestino está inflamado, no absorbe nada'
}, {
  title: 'Hacer ejercicio te agota más',
  detail: 'porque tu cuerpo ya está en reserva mínima'
}];
export function PainPoints() {
  return <section className="py-20 relative bg-brand-darker" data-id="element-251">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-252">
        <FadeIn data-id="element-253">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-12 leading-tight text-brand-dark" data-id="element-254">
            ¿Te reconocés en alguna de estas frases?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-3 gap-2 mb-20" data-id="element-255">
          {pains.map((pain, i) => <FadeIn key={i} delay={i * 0.1} direction="up" data-id="element-256">
              <div className="bg-brand-cream border border-brand-border border-l-[3px] border-l-brand-terracotta p-3 rounded-xl h-full flex flex-col items-start gap-1.5 shadow-card" data-id="element-257">
                <span className="text-2xl leading-none" data-id="element-258">{pain.emoji}</span>
                <p className="text-[13px] md:text-sm italic text-brand-dark leading-snug" data-id="element-259">
                  "{pain.text}"
                </p>
              </div>
            </FadeIn>)}
        </div>

        {/* The cycle block */}
        <div className="max-w-3xl mx-auto" data-id="element-260">
          <FadeIn data-id="element-261">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 leading-tight text-brand-dark" data-id="element-262">
              ¿Por qué tu cuerpo no descansa aunque vos quieras?
            </h2>
            <p className="text-lg md:text-xl text-brand-terracotta text-center font-medium mb-12 leading-relaxed" data-id="element-263">
              El ciclo que te tiene atrapada y nadie te explicó
            </p>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-264">
            <div className="bg-brand-card border border-brand-border p-6 md:p-10 rounded-2xl mb-10 shadow-card" data-id="element-265">
              <div className="flex flex-col gap-3" data-id="element-266">
                {cycle.map((step, i) => <Fragment key={i} data-id="element-267">
                    <div className="flex items-start gap-3 text-brand-dark text-base md:text-lg font-medium flex-wrap" data-id="element-268">
                      <span className="text-2xl leading-none" data-id="element-269">
                        {step.emoji}
                      </span>
                      <span className="flex-1" data-id="element-270">
                        <span className="font-bold" data-id="element-271">{step.text}</span>{' '}
                        <span className="text-brand-terracotta font-bold" data-id="element-272">
                          →
                        </span>{' '}
                        <span className="text-brand-muted" data-id="element-273">{step.detail}</span>
                      </span>
                    </div>
                    {i < cycle.length - 1 && <div className="text-brand-terracotta text-2xl ml-3 leading-none" data-id="element-274">
                        ↓
                      </div>}
                  </Fragment>)}
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-275">
            <div className="space-y-3 mb-10" data-id="element-276">
              {negatives.map((neg, i) => <div key={i} className="flex items-start gap-3 bg-brand-cream border-l-[3px] border-l-brand-terracotta border border-brand-border p-4 rounded-xl shadow-card" data-id="element-277">
                  <XCircle className="w-6 h-6 text-brand-terracotta shrink-0 mt-0.5" data-id="element-278" />
                  <p className="text-brand-dark text-base md:text-lg leading-snug" data-id="element-279">
                    <span className="font-bold" data-id="element-280">{neg.title}</span>{' '}
                    <span className="text-brand-muted" data-id="element-281">— {neg.detail}</span>
                  </p>
                </div>)}
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-282">
            <div className="flex items-start gap-3 bg-brand-softGreen border-2 border-brand-verifiedGreen p-6 rounded-2xl" data-id="element-283">
              <CheckCircle2 className="w-7 h-7 text-brand-accent shrink-0 mt-0.5" data-id="element-284" />
              <p className="text-brand-accent text-lg md:text-xl font-bold leading-relaxed" data-id="element-285">
                No es fuerza de voluntad. Es biología. Y tiene solución — si
                sabés por dónde empezar. ✅
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}